import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const min3LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 3});
const min5LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 5});
const min6LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 6});
const max255LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 255});
const max500LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 500});
const minValue30Message = () => i18n.t("validation.minNumber", {ns: "common", min: 30});
const minValue60Message = () => i18n.t("validation.minNumber", {ns: "common", min: 60});
const minValue100Message = () => i18n.t("validation.minNumber", {ns: "common", min: 100});
const ibanFormatMessage = () => i18n.t("validation.ibanFormat", {ns: "common"});
const taxtNumberFormatMessage = () => i18n.t("validation.taxtNumberFormat", {ns: "common"});

export const newCompanyValidation = yup.object().shape({
    companyName: yup.string().required(requiredMessage),
    companyCode: yup
        .number()
        .min(100, minValue100Message)
        .required(requiredMessage),
    city: yup.string().required(requiredMessage),
    county: yup.string().required(requiredMessage),
    address: yup
        .string()
        .min(5, min5LengthsMessage)
        .max(500, max500LengthsMessage)
        .required(requiredMessage),
    registeredTaxOffice: yup
        .string()
        .min(3, min3LengthsMessage)
        .max(255, max255LengthsMessage)
        .required(requiredMessage),
    taxNumber: yup
        .string()
        // VKN 10 haneli ve 0 ile başlayabilir; TCKN 11 haneli ve 0 ile başlayamaz
        .matches(/^([0-9]{10}|[1-9][0-9]{10})$/, taxtNumberFormatMessage)
        .required(requiredMessage),
    bankName: yup.string().required(requiredMessage),
    iban: yup
        .string()
        .matches(/^TR[0-9]{24}$/, ibanFormatMessage)
        .required(requiredMessage),
    billInformation: yup
        .string()
        .min(6, min6LengthsMessage)
        .max(255, max255LengthsMessage)
        .required(requiredMessage),
    courierTypes: yup.array().required(requiredMessage),
    targetDeliveryTime: yup.number().required(requiredMessage),
    locationUpdateInterval: yup
        .number()
        .nullable(true)
        .min(60, minValue60Message),
    heartbeatInterval: yup
        .number()
        .nullable(true)
        .min(30, minValue30Message),
    courierSearchDistance: yup.number().required(requiredMessage)
});
